module.exports = __webpack_public_path__ + "static/img/yilihe-2.0525e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yilihe-2.png
// module id = dfVo
// module chunks = 0